<template>
  <div class="loading-statistic-card width-responsiveness">
    <div class="loading-statistic-card__card-info bg-card">
      <div class="loading-statistic-card__card-info-text-content">
        <div class="loading-statistic-card__card-info-count-available-results field-darker field-1" />
        <div class="field-darker field-3" />
      </div>
      <div class="loading-statistic-card__card-info-text-content">
        <div class="loading-statistic-card__card-info-count-available-results field-darker field-4" />
        <div class="field-smooth field-5" />
        <div class="field-darker field-5" />
        <div class="field-smooth field-6" />
        <div class="field-darker field-7" />
      </div>
    </div>
    <div class="loading-statistic-card__card-info bg-card">
      <div class="loading-statistic-card__card-info-text-content">
        <div class="loading-statistic-card__card-info-count-available-results field-darker field-1" />
        <div class="field-darker field-3" />
      </div>
      <div class="loading-statistic-card__card-info-text-content">
        <div class="loading-statistic-card__card-info-count-available-results field-darker field-4" />
        <div class="field-smooth field-5" />
        <div class="field-darker field-5" />
        <div class="field-smooth field-6" />
        <div class="field-darker field-7" />
      </div>
    </div>
    <div class="loading-statistic-card__card-info bg-card">
      <div class="loading-statistic-card__card-info-text-content">
        <div class="loading-statistic-card__card-info-count-available-results field-darker field-1" />
        <div class="field-darker field-3" />
      </div>
      <div class="loading-statistic-card__card-info-text-content">
        <div class="loading-statistic-card__card-info-count-available-results field-darker field-4" />
        <div class="field-smooth field-5" />
        <div class="field-darker field-5" />
        <div class="field-smooth field-6" />
        <div class="field-darker field-7" />
      </div>
    </div>


    <div class="loading-statistic-card__card-info bg-card">
      <div class="loading-statistic-card__card-info-text-content">
        <div class="loading-statistic-card__card-info-count-available-results field-darker field-1" />
        <div class="field-darker field-3" />
      </div>
      <div class="loading-statistic-card__card-info-text-content">
        <div class="loading-statistic-card__card-info-count-available-results field-darker field-4" />
        <div class="field-smooth field-5" />
        <div class="field-darker field-5" />
        <div class="field-smooth field-6" />
        <div class="field-darker field-7" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoagindStatisticCard'
}
</script>
<style lang="scss" scoped>

  .bg-card {
    border-radius: 6px;
    background-color: #ffffff;
    animation: loading 1.5s infinite;
    background-position: -400px;
    background-size: 100% 100%;
    background-image: linear-gradient(90deg,hsla(0, 20%, 97.1%, 0.4),hsla(0, 2.1%, 62.7%, 0.2) 50%,hsl(0, 0%, 100%));
    background-repeat: no-repeat;
  }

  .loading-statistic-card {
    display: flex;
    width: 100%;

    &__card-info {
      background-color: white;
      padding: 12px;
      border-radius: 5px;
      cursor: progress;
      margin-right: 20px;
      width: 18em;

      &-count-available-results {
        padding: 12px;
        border-radius: 5px;
        margin: auto;
      }

      &-text-content {
        padding: 5px;
        line-height: 16px;
        margin-top: auto;
        margin-left: 0.5em;
      }

    }
  }

  .field {
    &-smooth {
      height: 12px;
      opacity: 0.1;
      border-radius: 3px;
      background-color: #858585;
    }
    &-darker {
      margin-top: 10px;
      height: 14px;
      opacity: 0.1;
      border-radius: 3px;
      background-color: #111111;
    }
    &-1{
      margin-right: 10px;
      height: 44px;
      width: 44px;
    }
    &-2{
      width: 140px;
    }
    &-3{
      height: 2px;
      width: 100%;
    }
    &-4{
      width: 40px;
      height: 50px;
      margin-top: 15px;
      margin-bottom: 10px;
    }
    &-5{
      width: 100px;
      margin: auto auto 10px auto;
    }
    &-6{
      width: 100%;
      height: 40px;
      margin-top: 30px;
    }
    &-7{
      width: 100%;
      height: 40px;
      margin-top: 10px;
      margin-bottom: 20px
    }
  }

    @keyframes loading {
    to {
      background-position: 400px;
    }
  }

</style>
